import { Component, Inject, OnInit, Optional, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import { AnalyticsService } from '../../core/analytics';
import * as meet from '../../actions/meet';
import { CustomersNameService } from 'spotlight-ui/app/shared/customer-names.service';
import { AdditionalFilterCustomersBase } from '../additional-filter-customers-base';

@Component({
  selector: 'additional-filter-customers-dialog',
  templateUrl: 'additional-filter-customers-dialog.component.html',
  styleUrls: ['./additional-filter-customers-dialog.component.scss'],
  providers: [CustomersNameService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class AdditionalFilterCustomersDialogComponent extends AdditionalFilterCustomersBase implements OnInit {

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) private dialogData: any,
    store: Store<fromRoot.State>,
              public dialogRef: MatDialogRef<AdditionalFilterCustomersDialogComponent>,
              analytics: AnalyticsService,
              customersNameService: CustomersNameService,
  ) {
    super(store, analytics, customersNameService);
  }

  public ngOnInit() {
    this.filterTitle = this.dialogData.filterTitle;
    this.id = this.dialogData.id;
    this.page = this.dialogData.page;
    this.initializeColumns();
    this.updateCustomerNames();
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public removedCustomer() {
    const customers = this.getSelectedCustomers();
    switch (this.id) {
      case this.MeetConstants.includeFilterId: {
        this.analytics.sendEvent(
          `${this.page} Page Included Individual Customer Removed Via Dialog`,
          {
            'Customer Id': customers,
          }
        );
        this.store.dispatch(new meet.RemoveIncludeCustomers({ customers, page: this.page }));
        break;
      }
      case this.MeetConstants.excludeFilterId: {
        this.analytics.sendEvent(
          `${this.page} Page Excluded Individual Customer Removed Via Dialog`,
          {
            'Customer Id': customers,
          }
        );
        this.store.dispatch(new meet.RemoveIndividualExcludeCustomer({ customers, page: this.page }));
        break;
      }
      case this.MeetConstants.savedGroupsFilterId: {
        this.analytics.sendEvent(
          'Saved Group Customer Removed',
          {
            'Group Id': this.selectedSavedGroupId,
            'Customer Ids': this.customerSelections,
          }
        );
        this.store.dispatch(new meet.RemoveSelectedSavedGroupCustomer(customers));
        this.store.dispatch(new meet.AddIndividualExcludeCustomer({ customers:  customers, page: this.page }));
        break;
      }
    }
    this.customerSelections = [];
    this.customerNamesLoading = true;
    this.updateCustomerNames();
  }
}
